<template>
  <button v-if="!to" :type="type" :disabled="loading || disabled" class="button" :class="{ loading }" v-bind="$attrs">
    <ButtonContent :loading="loading">
      <slot />
    </ButtonContent>
  </button>

  <RouterLink v-else #default="{ navigate }" :to="to" custom>
    <button
      type="button"
      :disabled="loading || disabled"
      class="button"
      :class="{ loading }"
      v-bind="$attrs"
      @click="click($event, navigate)"
      @keypress.enter="click($event, navigate)"
    >
      <ButtonContent :loading="loading">
        <slot />
      </ButtonContent>
    </button>
  </RouterLink>
</template>

<script setup>
import { RouterLink } from 'vue-router'

import ButtonContent from './ButtonContent'

const props = defineProps({
  type: {
    type: String,
    default: 'button',
  },
  to: {
    type: [String, Object],
    default: undefined,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

function click(e, navigate) {
  if (props.loading) return

  navigate(e)
}
</script>

<style lang="postcss" scoped>
.button {
  @apply relative inline-flex justify-center p-4 w-full font-main;
  @apply text-sm font-medium outline-none rounded-md cursor-default overflow-hidden;
  @apply border border-transparent text-white;
  @apply transition-all duration-300;
}
.button::before {
  @apply absolute top-0 right-0 bottom-0 left-0 bg-red-600;
  content: '';
}
.button:not(:disabled):hover {
  @apply cursor-pointer;
}
.button:not(:disabled):hover::before {
  @apply bg-opacity-75;
}
.button:not(:disabled):focus {
  @apply ring-2 ring-red-500 ring-offset-2 ring-offset-gray-900;
}
.button:disabled:before {
  @apply opacity-50;
}

.loading:deep(.button__content) {
  @apply opacity-0;
}
</style>
